"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConcordiumWalletClient = void 0;
var ConcordiumWalletQrModal_1 = require("./ConcordiumWalletQrModal");
var TypedEventEmitter_1 = __importDefault(require("./TypedEventEmitter"));
var utils_1 = require("./utils");
var BridgeMessageStatus_1 = require("./BridgeMessageStatus");
var ConcordiumWalletClient = /** @class */ (function () {
    function ConcordiumWalletClient(opts) {
        this.pubSub = TypedEventEmitter_1.default;
        this.bridgeHost = opts.bridgeHost;
        this.bridgeConnectionKey = opts.bridgeConnectionKey;
        var qrModalOpts = {
            onClose: this.disconnect.bind(this)
        };
        this.qrModal = opts.qrModal
            // eslint-disable-next-line new-cap
            ? new opts.qrModal(qrModalOpts)
            : new ConcordiumWalletQrModal_1.ConcordiumWalletQrModal(qrModalOpts);
    }
    ConcordiumWalletClient.prototype.connect = function () {
        this.ws = new WebSocket(this.getBridgeHost() + "/ws/web/frame/" + this.bridgeConnectionKey + "/-");
        this.initWebsocketListeners();
    };
    ConcordiumWalletClient.prototype.send = function (type, data) {
        if (this.ws) {
            this.ws.send((0, utils_1.createBridgeMessage)(type, data));
        }
    };
    ConcordiumWalletClient.prototype.getBridgeHost = function () {
        if (this.bridgeHost.startsWith('ws')) {
            return this.bridgeHost;
        }
        return "wss://" + this.bridgeHost;
    };
    ConcordiumWalletClient.prototype.saveConnectionCredential = function (msg) {
        this.sessionId = msg.session_id;
        this.connectId = msg.connect_id;
    };
    ConcordiumWalletClient.prototype.initWebsocketListeners = function () {
        var _this = this;
        if (!this.ws) {
            console.error('WS is not defined');
            return;
        }
        this.ws.onopen = function (event) {
            console.info('WS open', event);
        };
        this.ws.onclose = function (event) {
            _this.ws = null;
            console.info('WS onclose', event);
        };
        this.ws.onerror = function (error) {
            console.error('WS onerror', error);
        };
        this.ws.onmessage = function (event) {
            var _a = (0, utils_1.parseBridgeMessage)(event), type = _a[0], msg = _a[1];
            console.log('WS.onmessage', type, msg);
            switch (true) {
                case BridgeMessageStatus_1.BridgeMessageStatus.isWaitingForConnect(type, msg):
                    _this.qrModal.open(msg);
                    break;
                case BridgeMessageStatus_1.BridgeMessageStatus.isConnected(type, msg):
                    _this.saveConnectionCredential(msg);
                    _this._connected = true;
                    _this.pubSub.emit('connect');
                    break;
                case BridgeMessageStatus_1.BridgeMessageStatus.isAccepted(type, msg):
                    _this._accepted = true;
                    _this.pubSub.emit('accept');
                    break;
                case BridgeMessageStatus_1.BridgeMessageStatus.isRejected(type, msg):
                    _this._accepted = false;
                    _this._connected = false;
                    if (BridgeMessageStatus_1.BridgeMessageStatus.isTransactionRejected(type, msg)) {
                        _this.pubSub.emit('transactionReject', msg.data || msg.c);
                    }
                    else {
                        _this.pubSub.emit('connectionReject', msg.data || msg.c);
                    }
                    _this.pubSub.emit('reject', msg.data || msg.c);
                    _this.disconnect();
                    break;
                case BridgeMessageStatus_1.BridgeMessageStatus.isAccountInfoResponse(type, msg):
                    _this.pubSub.emit('accountInfo', msg.data || msg.c);
                    break;
                case BridgeMessageStatus_1.BridgeMessageStatus.isSimpleTransferResponse(type, msg):
                    _this.pubSub.emit('transfer', msg);
                    break;
                case BridgeMessageStatus_1.BridgeMessageStatus.isTransactionResponse(type, msg):
                    _this.pubSub.emit('transaction', msg.data || msg.c);
                    break;
                case BridgeMessageStatus_1.BridgeMessageStatus.isError(type, msg):
                    _this.pubSub.emit('error', msg);
                    break;
            }
        };
    };
    ConcordiumWalletClient.prototype.on = function (eventType, cb) {
        var _this = this;
        this.pubSub.on(eventType, cb);
        return function () { return _this.pubSub.off(eventType, cb); };
    };
    ConcordiumWalletClient.prototype.of = function (eventType, cb) {
        this.pubSub.off(eventType, cb);
    };
    ConcordiumWalletClient.prototype.disconnect = function () {
        var _a, _b;
        this.pubSub.emit('disconnect');
        (_a = this.ws) === null || _a === void 0 ? void 0 : _a.close();
        (_b = this.qrModal) === null || _b === void 0 ? void 0 : _b.close();
        this._connected = false;
        this._accepted = false;
        this.pubSub.clearAll();
    };
    Object.defineProperty(ConcordiumWalletClient.prototype, "connected", {
        get: function () {
            return this._connected;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConcordiumWalletClient.prototype, "accepted", {
        get: function () {
            return this._accepted;
        },
        enumerable: false,
        configurable: true
    });
    return ConcordiumWalletClient;
}());
exports.ConcordiumWalletClient = ConcordiumWalletClient;
